import React from 'react'

import strings from './strings.json'

//* Styles
import styles from './Footer.module.scss'

const MAIN_DOMAIN = 'https://filotrack.com'

const SOCIALS = {
    "facebook": {
        "icon_name": "logo-facebook",
        "label": "facebook",
        "path": ""
    },
    "twitter": {
        "icon_name": "logo-twitter",
        "label": "twitter",
        "path": ""
    },
    "instagram": {
        "icon_name": "logo-instagram",
        "label": "instagram",
        "path": ""
    },
}

const PRIVACY_POLICY = {
    "label": "Privacy Policy",
    "path": "https://www.iubenda.com/privacy-policy/959228"
}

const APPS = {
    "app_store": {
        "img": "https://filotrack.com/wp-content/uploads/I_Apple_Store.png",
        "path": "https://apps.apple.com/it/app/filo-find-locate-what-you-care-about/id950467121"
    },
    "google_play": {
        "img": "https://filotrack.com/wp-content/uploads/I_Play_Store.png",
        "path": "https://play.google.com/store/apps/details?id=com.filotrack.filo&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    },
}

const COPYRIGHT = "- © 2014 - 2022 Filo Srl - All rights reserved Filo Srl - Viale dei Santi Pietro e Paolo, 24, 00144, Rome (RM) - Italy P.IVA/CF:13008741004 - REA: RM - 1417094 - S.C. 25.174,28 €"

const Footer = () => {

    const LANG = document.documentElement.lang.substring(0, 2)
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

    const FOOTER_MENU = {
        "shop": STRINGS_LANG.shop,
        "learn": STRINGS_LANG.learn,
        "support": STRINGS_LANG.support,
        "company": STRINGS_LANG.company,
    }

    function goToPage(page){

        const LANG = document.documentElement.lang.substring(0, 2)
        const PAGE_LANG = LANG === "en" ? "/" : `/${LANG}`
        let url;

        if(page.link.startsWith('https://')){
            url = page.link;
        } else {
            url = `${MAIN_DOMAIN}${PAGE_LANG}${page.link}`
        }

        window.location.href = url

    }

    function goToPrivacyPolicy(){
        window.open(PRIVACY_POLICY.path, "_blank")
    }

    function goToApp(app){
        window.open(app.path, "_blank")
    }

  return (
    <footer className={styles['main-footer']}>
        <div className={styles["footer-container"]}>
            <div className={styles["social-container"]}>
                <p>{STRINGS_LANG["follow_us"]}</p>
                <div className={styles["socials-icon-container"]}
                >
                    {
                        Object.entries(SOCIALS).map(([socialKey, socialInfo]) => {

                            return(
                                <div className={styles["social"]}
                                    key={`footer-social-${socialKey}-de`}
                                >
                                    <div className={styles["social-icon-container"]}>
                                        <ion-icon name={socialInfo.icon_name}></ion-icon>
                                    </div>
                                </div>
                            )

                        })
                    }
                </div>
            </div>
            <div className={styles["footer-menu-container"]}>
                <div className={styles["logo-container"]}>
                    <img src={"https://filotrack.com/wp-content/uploads/Logo_Filo_White.png"} alt="logo-filo" />
                </div>
                {
                    Object.entries(FOOTER_MENU).map(([tabKey, tabInfo]) => {

                        return(
                            <div className={styles["footer-tab-container"]}
                                key={`footer-tab-${tabKey}-${LANG}`}
                            >
                                <div className={styles["tab-label"]}>
                                    <p>{tabInfo.label}</p>
                                </div>
                                {
                                    Object.entries(tabInfo.menu).map(([ menuKey, menuInfo]) => {

                                        // if(menuInfo.show === false) return null;

                                        return(
                                            <div className={styles["footer-tab-menu-item"]}
                                                key={`footer-menu-item-${menuKey}-${LANG}`}
                                                onClick={() => goToPage(menuInfo)}
                                            >
                                                <p className={styles['menu-item-label']}>{menuInfo.label}</p>
                                            </div>
                                        )

                                    })
                                }
                            </div>
                        )

                    })
                }
            </div>
            <div className={styles["privacy-policy-container"]}>
                <p>
                    <span className={styles["privacy-policy-link"]}
                        onClick={() => goToPrivacyPolicy()}
                    >{PRIVACY_POLICY.label}</span>
                    {COPYRIGHT}
                </p>
            </div>
            <div className={styles["apps-container"]}>
                {
                    Object.entries(APPS).map(([appKey, appInfo]) => {

                        return(
                            <img src={appInfo.img} alt={appKey} 
                                key={`footer-app-${appKey}`}
                                onClick={() => goToApp(appInfo)}
                            />
                        )

                    })
                }
            </div>
        </div>
    </footer>
  )
}

export default Footer